import React from 'react';

import InlineSVG from 'components/InlineSVG';
import replyIcon from './reply.svg?inline';

function ReplyIcon() {
  return <InlineSVG svg={replyIcon} />;
}
export default ReplyIcon;
